import { BookingDialogActionType } from "./Actions";
import { IBookingDialogState } from "./Models";
import { SearchActionType } from "./Search/Actions";

export const createBookingDialogReducer = (visible?: boolean) => {

	const initialState = setInitialState(visible);

	return (state: IBookingDialogState = initialState, action: { type?: BookingDialogActionType|SearchActionType }): IBookingDialogState => {
		switch(action.type) {
			case "showDialog":
				return { ...state, ...{ visible: true, step: (action as any).search ? "search" : state.step } };
			case "setStep":
				return { ...state, ...{ step: (action as any).step }};
			case "searchJourneyStarted":
				return { ...state, ...{ step: "timetable" }};
			case "createBookingComplete":
				return { ...state, ...{ step: "passengersandpayment" }};
			case "openSeatmap":
				return { ...state, ...{ step: "seatmap" }};
			case "closeSeatmap":
				return { ...state, ...{ step: "passengersandpayment" }};

			default:
				return state;
		}
	};

	function setInitialState(visible?: boolean): IBookingDialogState {
		return { step: "search", visible: visible || false };
	}
};